module.exports = __webpack_public_path__ + "static/media/food_trucks(1).503206e1.jpg";